module.exports = __webpack_public_path__ + "media/images/emblems/Lussy-sur-Morges-coat_of_arms-d45ce7c4e2df4219eb35ed1426761a6f.svg";